import { render } from "./esco-esqueci-senha.vue?vue&type=template&id=a087b11e&scoped=true"
import script from "./esco-esqueci-senha.vue?vue&type=script&lang=js"
export * from "./esco-esqueci-senha.vue?vue&type=script&lang=js"

import "./esco-esqueci-senha.vue?vue&type=style&index=0&id=a087b11e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a087b11e"]])

export default __exports__